import React, { useState } from "react";
import * as S from "./dateFilter.style";
import { ReactComponent as IconArrowLeft } from "../../../styles/assets/svg/left-arrow.svg";
import { ReactComponent as IconArrowRight } from "../../../styles/assets/svg/right-arrow.svg";
import dayjs from "dayjs";
import DatePickerModal from "../DatePickerModal";

type DateFilterType = {
  currentDate: dayjs.Dayjs;
  onDateChange: (date: dayjs.Dayjs) => void;
};

/** 날짜 필터 컴포넌트  */
const DateFilter = ({ currentDate, onDateChange }: DateFilterType) => {
  /** ============================= state 영역 ============================= */
  // 날짜부분 클릭 시 날자 선택 모달 open 상태값
  const [isModalOpen, setIsModalOpen] = useState(false);

  /** ============================= API 영역 ============================= */

  /** ============================= 비즈니스 로직 영역 ============================= */
  /** 이전 달 클릭 시 날짜 변경 상태값 */
  const handlePrevMonth = () => {
    const prevMonth = currentDate.subtract(1, "month");
    onDateChange(prevMonth);
  };

  /** 다음 달 클릭 시 날짜 변경 상태값 */
  const handleNextMonth = () => {
    const nextMonth = currentDate.add(1, "month");
    onDateChange(nextMonth);
  };

  /** 날짜 표시 부분 클릭 시 날짜 선택 모달 open 상태값 */
  const handleDateDisplayClick = () => {
    setIsModalOpen(true);
  };

  /** 날짜 선택 모달 close 상태값 */
  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  /** 날짜 선택 모달 날짜 선택 시 날짜 변경 상태값 */
  const handleDateSelect = (date: dayjs.Dayjs) => {
    onDateChange(date);
  };
  /** ============================= 컴포넌트 영역 ============================= */

  /** ============================= useEffect 영역 ============================= */

  return (
    <>
      <S.DateFilterContainer>
        <S.DateFilterWrapper>
          <S.ArrowButton onClick={handlePrevMonth}>
            <IconArrowLeft width={10} height={15} />
          </S.ArrowButton>
          <S.DateDisplay onClick={handleDateDisplayClick}>
            {currentDate.format("YYYY. MM")}
          </S.DateDisplay>
          <S.ArrowButton onClick={handleNextMonth}>
            <IconArrowRight width={10} height={15} />
          </S.ArrowButton>
        </S.DateFilterWrapper>
      </S.DateFilterContainer>
      {/* 날짜 선택 모달 */}
      <DatePickerModal
        isOpen={isModalOpen}
        onClose={handleModalClose}
        currentDate={currentDate}
        onDateSelect={handleDateSelect}
      />
    </>
  );
};

export default DateFilter;
